import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatsList',
  setup(__props) {

const { i18n } = useContext();

const stats = computed(() => {
  return [
    {
      headerInfo: i18n.t('components.nodes.statsList.100') as string,
      primaryText: i18n.t('components.nodes.statsList.everyTitle') as string,
      supportingText: i18n.t('components.nodes.statsList.liveIn') as string,
    },
    {
      headerInfo: i18n.t('components.nodes.statsList.1Billion') as string,
      primaryText: i18n.t('components.nodes.statsList.sinceLaunch') as string,
      supportingText: i18n.t('components.nodes.statsList.ownership') as string,
    },
    {
      headerInfo: '58,000',
      primaryText: i18n.t('components.nodes.statsList.onAverage') as string,
      supportingText: i18n.t(
        'components.nodes.statsList.gamesMusicFun',
      ) as string,
    },
  ];
});

return { __sfc: true,i18n, stats }
}

})